import { NavigateBackLink } from '@exam-center/components';
import { useExamEventDetails } from '@exam-center/exam-event-management';
import { useParams } from '@exam-center/router';
import { formatStartToEndTime } from '@exam-center/utils';
import { Flex, PageHeader, Text } from '@shared/components';

import { calculateDuration } from '../../components/exam-session-card/utils/utils';
import { useExamEventSessionDetails } from '../../providers';

export default function ProctoringExamSessionDetailsPageHeader() {
  const { examCenterCode, examEventId } = useParams(
    '/:examCenterCode/proctoring/exam-events/:examEventId/details/session/:examSessionId',
  );

  const { examEventSession } = useExamEventSessionDetails();
  const { examEvent } = useExamEventDetails();

  const { round, startedAt, endedAt } = examEventSession;

  return (
    <PageHeader
      title={`ช่วงสอบที่ ${round}`}
      subtitleSection={
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(4),
            color: theme.palette.text.secondary,
          })}
        >
          <Text variant='body2'>เวลาสอบ: {formatStartToEndTime(startedAt, endedAt)}</Text>
          <Text variant='body2'>ระยะเวลาสอบ: {calculateDuration(startedAt, endedAt)}</Text>
          <Text variant='body2'>รอบสอบที่: {examEvent.roundNumber}</Text>
        </Flex>
      }
      linkAdornment={
        <NavigateBackLink
          to='/:examCenterCode/proctoring/exam-events/:examEventId/details'
          params={{
            examCenterCode: examCenterCode,
            examEventId: examEventId,
          }}
          label='Back'
        />
      }
    />
  );
}
